import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { keyForPath, canView, firstViewablePath } from "../lib/perms";
import Layout from "./Layout";

export default function ProtectedRoute({ children, bare = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory text-cocoa font-heading">
        Memuat...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // Route-level view guard based on custom role permissions
  const key = keyForPath(location.pathname);
  if (key && !canView(user, key)) {
    const dest = firstViewablePath(user);
    if (dest && dest !== location.pathname) return <Navigate to={dest} replace />;
    return (
      <Layout>
        <div data-testid="no-access" className="min-h-[60vh] flex flex-col items-center justify-center text-center">
          <div className="text-lg font-heading font-bold text-cocoa">Akses Ditolak</div>
          <div className="text-sm text-wmuted mt-1">Peran Anda tidak memiliki izin untuk membuka halaman ini.</div>
        </div>
      </Layout>
    );
  }

  const embed = new URLSearchParams(window.location.search).get("embed") === "1";
  return bare || embed ? <>{children}</> : <Layout>{children}</Layout>;
}
